import * as React from 'react';
import styled from 'styled-components';

import { useParams } from 'react-router';
import { Container } from './Container';
import { PropertyCard } from './PropertyCard';
import { Pagination } from '../ui/pagination/Pagination';
import { PropertyHighLightedCarousel } from './carousel/PropertyHighlightedCarousel';
import { H1 } from './HeaderTitle';

import { env } from '../../__config__/env';
import { AssignmentType, Estate, SearchEstateSort, useSearchEstateQuery } from '../../__types__/generated/cluster';
import { client } from '../../../client/__graphql__/clusterClient';

const SectionNewDevelopmentStyle = styled.div``;
const PaginationWrapper = styled.div``;

export const CardContainerStyle = styled.div`
  width: 100%;
  margin: 0 auto;
  margin-top: 1em;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  grid-column-gap: 20px;
  text-align: center;
  grid-row-gap: 40px;

  @media all and (max-width: 1150px) {
    grid-template-columns: 1fr 1fr;
  }
  @media all and (max-width: 750px) {
    grid-template-columns: 1fr;
    grid-row-gap: 40px;
  }
`;

export const SectionNewDevelopment: React.FC<{
  is_ready?: boolean;
  showProperties: boolean;
  showHighlighedProperty?: boolean;
  showTitle?: boolean;
  limit?: number;
}> = ({ showProperties, showHighlighedProperty, showTitle, limit }) => {
  const params = useParams<{ urltag: string }>();
  const [page, setPage] = React.useState(0);
  const pRef = React.useRef<any>(null);

  const { data } = useSearchEstateQuery({
    client: client,
    skip: !(showProperties || showHighlighedProperty),
    fetchPolicy: 'network-only',
    variables: {
      input: {
        brandId: env.BRAND_ID
      },
      filter: {
        sort: SearchEstateSort.PublishedNewOld,
        assignmentTypes: [AssignmentType.NewDevelopment, AssignmentType.NewDevelopmentCommercial, AssignmentType.NewDevelopmentLeisure],
        tags: params?.urltag ? [params?.urltag] : ['newdevelopment'],
        sold: false,
        isProjectUnit: false,
        published: true,
        available: true,
        pagination: {
          limit: limit && limit > 0 ? limit : 3,
          page: page
        }
      }
    }
  });

  if (showProperties || showHighlighedProperty) {
    return (
      <SectionNewDevelopmentStyle>
        <Container>
          {showTitle ? <H1 style={{ paddingBottom: '1em' }}>Aktuelle nybygg</H1> : null}

          {showHighlighedProperty ? (
            <>
              <PropertyHighLightedCarousel />
            </>
          ) : null}
          {showProperties ? (
            <>
              <CardContainerStyle ref={pRef}>
                {data?.search.estate?.list.map((item: any) => {
                  if (!item) return null;
                  const estate: Estate = item as Estate;

                  return <PropertyCard key={estate.estateId} estate={estate} showCardSticker></PropertyCard>;
                })}
              </CardContainerStyle>
              <PaginationWrapper>
                {data?.search.estate && data?.search.estate?.list?.length > 0 ? (
                  <Pagination
                    center
                    currentPage={page}
                    total={data?.search.estate.total ?? 0 - 1}
                    itemsPerPage={limit && limit > 0 ? limit : 3}
                    pageRangeDisplayed={3}
                    pageOnChange={({ selected }) => {
                      if (page != selected) {
                        setPage(selected);
                        if (pRef?.current && pRef?.current?.offsetTop > -1) {
                          const ypos = pRef?.current?.offsetTop - 100;
                          window.scrollTo({
                            top: ypos > 0 ? ypos : 0,
                            left: 0,
                            behavior: 'smooth'
                          });
                        }
                      }
                    }}
                  />
                ) : null}
              </PaginationWrapper>
            </>
          ) : null}
        </Container>
      </SectionNewDevelopmentStyle>
    );
  }

  return null;
};
